import { atom } from 'recoil';

let globalPopup = atom<any>({
  key: 'globalPopup',
  default: {
    open: false,
    message: '',
    onClickConfirm: () => {},
    onClickCancel: () => {},
    confirmText: '',
    cancelText: '',
  },
});

export { globalPopup };
